import { render } from "./jxcgBorder.vue?vue&type=template&id=90e90b76&scoped=true"
import script from "./jxcgBorder.vue?vue&type=script&lang=js"
export * from "./jxcgBorder.vue?vue&type=script&lang=js"

import "./jxcgBorder.vue?vue&type=style&index=0&id=90e90b76&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e90b76"]])

export default __exports__